/**
 * An immutable object mapping modal size keys to their corresponding Tailwind CSS width classes.
 *
 * @readonly
 * @enum {string}
 * @property {string} SM - Small modal size (343px width).
 * @property {string} MD - Medium modal size (544px width).
 * @property {string} LG - Large modal size (648px width).
 */
export const modalSizes = Object.freeze({
  SM: 'w-[343px] min-w-[343px]',
  MD: 'w-[544px] min-w-[544px]',
  LG: 'w-[648px] min-w-[648px]',
});

/**
 * An immutable object mapping modal event keys to their corresponding event names.
 *
 * @readonly
 * @enum {string}
 * @property {string} SHOW_MODAL - Event name for showing a modal.
 * @property {string} CLOSE_MODAL - Event name for closing a modal.
 * @property {string} MODAL_HAS_CLOSED - Event name indicating the modal has finished closing.
 */
export const modalEvents = Object.freeze({
  SHOW_MODAL: 'show-modal',
  CLOSE_MODAL: 'close-modal',
  MODAL_HAS_CLOSED: 'modal-has-closed',
  MODAL_HAS_OPENED: 'modal-has-opened',
});
